import { Sport } from '#src/__generated__/globalTypes.ts';
import { ASSETS_HOST } from '#src/config.ts';

export const useDefaultStadiumBackground = (sport: Sport) => {
  if (sport === Sport.FOOTBALL) {
    return `${ASSETS_HOST}/backgroundshopitem/0.png`;
  }
  return null;
};
